import Slider from 'react-slick';
import { SLIDER_PROPS } from '../types';

export const VerticalSlider = ({ children }: SLIDER_PROPS): JSX.Element => {
  const settings = {
    className: 'center',
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    initialSlide: 0,
    pauseOnHover: false,
    lazyload: 'progressive',
    autoplay: true,
    arrows: false,
  };
  return <Slider {...settings}>{children}</Slider>;
};
